import { createUseData } from "../../../../../../../../common/hooks/create-use-data/create-use-data";
import { service } from "./demo-dashboard-grid-item.service";

export const useDashboardLink = createUseData(service.getDemoDashboardLink)